/**
 * Language Constants
 * 
 * Centralized configuration for supported languages in the application.
 * Used as fallback when Language API is unavailable and to avoid magic numbers.
 */

export const SUPPORTED_LANGUAGES = {
  ARABIC: { id: 1, code: 'ar', nameEn: 'Arabic', nameAr: 'عربي' },
  ENGLISH: { id: 2, code: 'en', nameEn: 'English', nameAr: 'إنجليزي' }
} as const;

/**
 * Default language ID to use when language selection fails or is unavailable.
 * Currently set to English (2).
 */
export const DEFAULT_LANGUAGE_ID = SUPPORTED_LANGUAGES.ENGLISH.id;

/**
 * Helper function to convert SUPPORTED_LANGUAGES to LanguageDto format
 * @returns Array of languages in LanguageDto format
 */
export function getSupportedLanguagesAsDto(): Array<{ id: string; code: string; nameEn: string; nameAr: string }> {
  return Object.values(SUPPORTED_LANGUAGES).map(lang => ({
    id: lang.id.toString(),
    code: lang.code,
    nameEn: lang.nameEn,
    nameAr: lang.nameAr
  }));
}
